<div class="where-wrapper">
  <div class="theme-input-mobile">
    <input #whereInput class="input where" [value]="displayValue" type="text" placeholder="Anywhere" (focus)="setFocus(true)">
    <span class="input-icon">
      <svg-icon style="height: 26px" [svgStyle]="{'width.px': 26, 'height.px': 26}" src="/assets/icons/marker_2.svg"></svg-icon>
    </span>
    <ng-container *ngIf="activeInput === 'where' && (focused | async) && (query | async)">
      <div class="search-overlay" (click)="setFocus(false)"></div>
      <div class="search-wrapper" [hidden]="!(showSearches | async) || !(query | async)">
        <div class="search-content">
          <div class="search-results">
            <div *ngFor="let place of places | async; trackBy: trackByCity" (click)="doUpdate(place)" class="search-result">
            <ng-container *ngIf="place.searchType === 1 || place.searchType === 4 || place.searchType === 5">
              <app-place [place]="place" [query]="whereInput.value"></app-place>
            </ng-container>
            <ng-container *ngIf="place.searchType === 2">
              <app-hostel [hostel]="place" [query]="whereInput.value"></app-hostel>
            </ng-container>
          </div>
            <div class="search-result noop" *ngIf="(places | async)?.length <= 0 && !(searching | async)">No results</div>
            <div class="search-result noop" *ngIf="(searching | async) && !(places | async)?.length">Searching places...</div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
  <ng-container *ngIf="activeInput === 'where' && (focused | async)">
    <div class="carousel-control-position" #carouselBounds @fadeIn>
      <div class="carousel-container" #carouselContainer>
        <div class="where-carousel">
          <ng-container *ngFor="let city of cities | async; let i = index">
            <!-- <div class="carousel-item" (click)="doUpdate({ city: city.name })" #carouselItem id="carousel_item_{{i}}"> -->
            <div class="carousel-item" (click)="doUpdate(city)" #carouselItem id="carousel_item_{{i}}">
              <div class="carousel-item-inner">
                <div class="img-container">
                  <img ngOptimizedImage [ngSrc]="city.url" [fill]="true">
                </div>
                <div>{{ city.cityName }}</div>
              </div>
            </div>
          </ng-container>
        </div>
        <button class="control control-left" #carouselLeftControl (click)="scrollLeft()">
          <svg-icon src="/assets/icons/left.svg"></svg-icon>
        </button>
        <button class="control control-right" #carouselRightControl (click)="scrollRight()">
          <svg-icon src="/assets/icons/right.svg"></svg-icon>
        </button>
      </div>
    </div>
  </ng-container>
</div>


<!-- <ng-container *ngIf="bottomSheetOpen | async">
  <div class="fixed-test">
    <button class="btn btn-large">
      <span>Skip</span>
    </button>

    <button class="btn btn-theme btn-large" [disabled]="!value || value.length < 2">
      <span>Select these dates</span>
    </button>
  </div>
</ng-container> -->
